import { useParams } from 'react-router-dom';
import { Container, Table, Text } from '@mantine/core';
import * as Sentry from '@sentry/react';
import { useQuery } from '@apollo/client';
import LoadingData from '@components/graphql-loading-data';
import GraphqlError from '@components/graphql-error';
import { QuestionState, QuestionType } from '@generated/graphql';
import { gql } from '@src/__generated__';

// findQuestionStates(tripProfileId: ID!): [QuestionState!]!

const GET_QUESTION_STATES = gql(`
  query SelectLayersRanks($tripProfileId: ID!, $questionType: QuestionType) {
    findQuestionStates(tripProfileId: $tripProfileId, questionType: $questionType) {
      id
      tripProfileId
      questionId
      questionType
      parentQuestionId
      rank
      question {
        id
        type
        text
        gisLayerId
      }
      ranks {
        rank
        text
        id
      }
    }
  }
`);

interface RowProps {
  data: QuestionState[] | undefined;
}
function Rows({ data }: RowProps) {
  if (!data) return <div />;
  const rows = data.map((item) => {
    let layerGroup = '';
    switch (item.parentQuestionId) {
      case '1':
        layerGroup = 'Physical';
        break;
      case '2':
        layerGroup = 'Cultural';
        break;
      case '3':
        layerGroup = 'History';
        break;
      default:
    }
    return (
      <Table.Tr key={item.id}>
        <Table.Td>{layerGroup}</Table.Td>
        <Table.Td>{item.question?.text}</Table.Td>
        <Table.Td>{item.ranks?.map((rank) => `${rank?.text} | `)}</Table.Td>
        <Table.Td>{item.question?.id}</Table.Td>
        <Table.Td>{item.question?.gisLayerId}</Table.Td>
      </Table.Tr>
    );
  });
  return rows;
}

function SelectLayersRanks() {
  const { tripProfileId } = useParams();

  const { loading, error, data } = useQuery(GET_QUESTION_STATES, {
    variables: {
      tripProfileId: tripProfileId || '',
      questionType: QuestionType.Layer,
    },
  });
  if (loading) return <LoadingData />;
  if (error) return <GraphqlError error={error} />;
  if (data && data.findQuestionStates.length !== 3) {
    Sentry.captureException(Error('Not exactly 3 result layers!'));
  }

  return (
    <Container fluid p={0}>
      <Text fw={700} fz="xs" c="var(--mantine-color-gray-6)" mb={4}>
        Layer Ranks (debug)
      </Text>

      <Table miw={800} verticalSpacing={5} fz="xs">
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Group</Table.Th>
            <Table.Th>Layer</Table.Th>
            <Table.Th>Ranked Values</Table.Th>
            <Table.Th>qn ID</Table.Th>
            <Table.Th>GIS Layer ID</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{data && <Rows data={data.findQuestionStates} />}</Table.Tbody>
      </Table>
    </Container>
  );
}

export default SelectLayersRanks;
